/* global shareSelectedText */
import React from 'react';
import Header from 'components/common/Header';
import ModalContainer from 'containers/modal';

import 'share-selected-text/dist/shareSelectedText';
import 'share-selected-text/dist/shareSelectedText.min.css';

class ContainerPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fixedHeader: false
    };

    // Bindings
    this.onScroll = this.onScroll.bind(this);
  }

  componentWillMount() {
    this.props.getPublicationsAndData();
  }

  componentDidMount() {
    window.addEventListener('scroll', this.onScroll);
    this.setShareText();
  }

  componentDidUpdate() {
    // In case share text tooltip is still visible & change page,
    // this removes it to avoid having two or more
    this.removeShareTextNode();
    this.setShareText();
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll);
  }

  onScroll() {
    const fixedHeader = this.header.refs['l-header'];
    if (fixedHeader) {
      const headerPos = fixedHeader.getBoundingClientRect().top;

      if (headerPos < -130) this.setState({ fixedHeader: true });
      else this.setState({ fixedHeader: false });
    }
  }

  /* UI events
   * Share selected text
   */

  setShareText() {
    const shareTextOpts = {
      tooltipClass: 'c-share-tooltip',
      sanitize: true, // respect the Twitter Max length
      buttons: [      // twitter, tumblr, reddit, linkedin, facebook...
        'facebook',
        'twitter'
      ],
      facebookAppID: config.appId,
      facebookDisplayMode: 'popup', // 'popup' || 'page'
      tooltipTimeout: 250  // Timeout before that the tooltip appear in ms
    };

    shareSelectedText('.l-main', shareTextOpts);
  }

  removeShareTextNode() {
    const element = document.querySelectorAll('.share-selected-text-main-container')[0];
    element.parentNode.removeChild(element);
  }

  render() {
    return (
      <div>
        <Header
          ref={(node) => { this.header = node; }}
          publicationsAndDataList={this.props.publicationsAndDataArr}
          menuOpen={this.props.menuOpen}
          toggleMenu={this.props.toggleMenu}
        />
        {this.state.fixedHeader &&
          <Header
            fixed={this.state.fixedHeader}
            publicationsAndDataList={this.props.publicationsAndDataArr}
            menuOpen={this.props.menuOpen}
            toggleMenu={this.props.toggleMenu}
          />
        }
        {this.props.children}
        <ModalContainer />
      </div>
    );
  }
}

ContainerPage.propTypes = {
  children: React.PropTypes.element.isRequired,
  publicationsAndDataArr: React.PropTypes.array,
  menuOpen: React.PropTypes.bool,
  // Actions
  getPublicationsAndData: React.PropTypes.func,
  toggleMenu: React.PropTypes.func
};

export default ContainerPage;



// WEBPACK FOOTER //
// ./app/components/common/Page.jsx